// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SMZR","colBig":"styles_colBig__7beUr","colSmall":"styles_colSmall__17c2c"};